import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams, AddressParamsModel } from 'Models'
import { SimpleResponse } from 'Types/simpleResponse'
import { AppointmentDataModel, AddressModel } from 'Pages/orders_design'

async function getCitiesRegions(requestParams: RequestParams) {
	const res = await axiosDS().get<SimpleResponse>(urls.orders.cities_regions, {
		params: requestParams,
	})
	return res.data
}

async function getSlots(requestParams: RequestParams) {
	const res = await axiosDS().get<SimpleResponse>(urls.orders.slots, {
		params: requestParams,
	})
	return res.data
}

async function createAppointment(order_id: number, data: AppointmentDataModel) {
	const res = await axiosDS().post<AppointmentDataModel>(urls.orders.appointment, {
		data,
		order_id,
	})
	return res.data
}

async function getAddress(params: AddressParamsModel) {
	const res = await axiosDS().get<AddressModel[]>(urls.dadata.address, { params })
	return res.data
}

async function getPaperlessStatus(requestParams: RequestParams) {
	const res = await axiosDS().get<SimpleResponse>(urls.orders.cm_status, {
		params: requestParams,
	})
	return res.data
}

export const outOfficeManagerApi = {
	getCitiesRegions,
	getSlots,
	createAppointment,
	getAddress,
	getPaperlessStatus,
}
